import React from 'react';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import { ReactComponent as CloseIcon } from 'assets/img/icons/new/close.svg';

export default function SelectMultiValue({ children, ...props }) {
  const { index, isDisabled, getValue, setValue, getStyles } = props;

  const labelStyles = getStyles('multiValueLabel', props);
  const crossIconStyles = getStyles('multiValueRemove', props);

  const onRemove = () => {
    if (isDisabled) return;
    const value = getValue();
    value.splice(index, 1);
    setValue(value);
  };

  return (
    <UiKit.Tag mode="dark" className={styles.mutiValue}>
      <span style={labelStyles}>{children}</span>
      <If test={!isDisabled}>
        <CloseIcon
          onClick={onRemove}
          onMouseDown={e => e.stopPropagation()}
          style={crossIconStyles}
          className="ml-1"
        />
      </If>
    </UiKit.Tag>
  );
}
